import * as Api from '@ViewModels';
import { useQuery } from '@tanstack/react-query';
import { useUserSession } from '../../../models/hooks/appStateHooks';

export const ADMIN_ACCOUNT_OPEN_INVOICES_QUERY_KEY = 'admin/account/openInvoices';

export function useAdminAccountOpenInvoicesQuery() {
	const userSession = useUserSession();
	return useQuery({
		queryFn: () =>
			userSession.webServiceHelper.callAsync<Api.IAccountOpenInvoices[]>(`admin/account/openInvoices`, 'GET'),
		queryKey: [ADMIN_ACCOUNT_OPEN_INVOICES_QUERY_KEY],
	});
}
